module.exports = __webpack_public_path__ + "img/sumter-schools-logo.642d2538.jpg";